// si canvia algun camp revisar i actualitzar, per exemple, RealEstateEditor.vue funció "set_realestate_property_type"
export default [
    {
        'id': 1,
        'name_ca': 'Pis',
        'name_es': 'Piso',
        'name_en': 'Flat',
        'name_db': 'residential',
        'usage_type_ca': "Habitatge",
        'usage_type_en': "Dwelling",
        'usage_type_es': "Vivienda"
    },
    {
        'id': 2,
        'name_ca': 'Casa adossada',
        'name_es': 'Casa adosada',
        'name_en': 'Attached single-family house',
        'name_db': 'residential',
        'usage_type_ca': "Habitatge",
        'usage_type_en': "Dwelling",
        'usage_type_es': "Vivienda"
    },
    {
        'id': 3,
        'name_ca': 'Casa independent',
        'name_es': 'Casa independiente',
        'name_en': 'Detached single-family house',
        'name_db': 'residential',
        'usage_type_ca': "Habitatge",
        'usage_type_en': "Dwelling",
        'usage_type_es': "Vivienda"
    },
    {
        'id': 4,
        'name_ca': 'Apartament',
        'name_es': 'Apartamento',
        'name_en': 'Apartment',
        'name_db': 'residential',
        'usage_type_ca': "Habitatge",
        'usage_type_en': "Dwelling",
        'usage_type_es': "Vivienda"
    },
    {
        'id': 5,
        'name_ca': 'Loft',
        'name_es': 'Loft',
        'name_en': 'Loft',
        'name_db': 'residential',
        'usage_type_ca': "Habitatge",
        'usage_type_en': "Dwelling",
        'usage_type_es': "Vivienda"
    },
    {
        'id': 6,
        'name_ca': 'Estudi',
        'name_es': 'Estudio',
        'name_en': 'Studio',
        'name_db': 'office',
        'usage_type_ca': "Local sense accés directe",
        'usage_type_en': "Commercial premise without direct access",
        'usage_type_es': "Local sin acceso directo"
    },
    {
        'id': 7,
        'name_ca': 'Dúplex',
        'name_es': 'Dúplex',
        'name_en': 'Duplex',
        'name_db': 'residential',
        'usage_type_ca': "Habitatge",
        'usage_type_en': "Dwelling",
        'usage_type_es': "Vivienda"
    },
    {
        'id': 8,
        'name_ca': 'Triplex',
        'name_es': 'Triplex',
        'name_en': 'Triplex',
        'name_db': 'residential',
        'usage_type_ca': "Habitatge",
        'usage_type_en': "Dwelling",
        'usage_type_es': "Vivienda"
    },
    {
        'id': 9,
        'name_ca': 'Edifici',
        'name_es': 'Edificio',
        'name_en': 'Building',
        'name_db': 'entire_buildings',
        'usage_type_ca': "Edifici",
        'usage_type_en': "Building",
        'usage_type_es': "Edificio"
    },
    {
        'id': 10,
        'name_ca': 'Plaça d\'aparcament',
        'name_es': 'Plaza de aparcamiento',
        'name_en': 'Parking space',
        'name_db': 'parking',
        'usage_type_ca': "Aparcament",
        'usage_type_en': "Parking",
        'usage_type_es': "Aparcamiento"
    },
    {
        'id': 11,
        'name_ca': 'Garatge',
        'name_es': 'Garaje',
        'name_en': 'Parking',
        'name_db': 'parking',
        'usage_type_ca': "Aparcament",
        'usage_type_en': "Parking",
        'usage_type_es': "Aparcamiento"
    },

    {
        'id': 12,
        'name_ca': 'Finca rústica',
        'name_es': 'Finca rústica',
        'name_en': 'Rural house',
        'name_db': 'residential',
        'usage_type_ca': "Finca rústica",
        'usage_type_en': "Rural house",
        'usage_type_es': "Finca rústica"
    },
    {
        'id': 13,
        'name_ca': 'Masia',
        'name_es': 'Masía',
        'name_en': 'Farmhouse',
        'name_db': 'residential',
        'usage_type_ca': "Finca rústica",
        'usage_type_en': "Rural house",
        'usage_type_es': "Finca rústica"
    },
    {
        'id': 14,
        'name_ca': 'Piscina',
        'name_es': 'Piscina',
        'name_en': 'Swimming pool',
        'name_db': 'residential',
        'usage_type_ca': "Piscina",
        'usage_type_en': "Swimming pool",
        'usage_type_es': "Piscina"
    },
    {
        'id': 15,
        'name_ca': 'Traster',
        'name_es': 'Trastero',
        'name_en': 'Storage room',
        'name_db': 'storage',
        'usage_type_ca': "Traster",
        'usage_type_en': "Storage",
        'usage_type_es': "Traster"
    },
    {
        'id': 16,
        'name_ca': 'Pista esportiva',
        'name_es': 'Pista deportiva',
        'name_en': 'Sports pitch',
        'name_db': 'retail_and_industrial',
        'usage_type_ca': "Pista esportiva",
        'usage_type_en': "Sports pitch",
        'usage_type_es': "Finca rústica"
    },
    {
        'id': 17,
        'name_ca': 'Club esportiu',
        'name_es': 'Club deportivo',
        'name_en': 'Sports club',
        'name_db': 'retail_and_industrial',
        'usage_type_ca': "Club esportiu",
        'usage_type_en': "Sports club",
        'usage_type_es': "Club deportivo"
    },
    {
        'id': 18,
        'name_ca': 'Local amb accés directe',
        'name_es': 'Local con acceso directo',
        'name_en': 'Commercial premise with direct access',
        'name_db': 'retail_and_industrial',
        'usage_type_ca': "Local amb accés directe",
        'usage_type_en': "Commercial premise with direct access",
        'usage_type_es': "Local con acceso directo"
    },
    {
        'id': 19,
        'name_ca': 'Local sense accés directe',
        'name_es': 'Local sin acceso directo',
        'name_en': 'Commercial premise without direct access',
        'name_db': 'office',
        'usage_type_ca': "Local sense accés directe",
        'usage_type_en': "Commercial premise without direct access",
        'usage_type_es': "Local sin acceso directo"
    },
    {
        'id': 20,
        'name_ca': 'Nau industrial',
        'name_es': 'Nave industrial',
        'name_en': 'Industrial warehouse',
        'name_db': 'retail_and_industrial',
        'usage_type_ca': "Nau industrial",
        'usage_type_en': "Industrial warehouse",
        'usage_type_es': "Nave industrial"
    },
    {
        'id': 21,
        'name_ca': 'Escola',
        'name_es': 'Escuela',
        'name_en': 'School',
        'name_db': 'retail_and_industrial',
        'usage_type_ca': "Escola",
        'usage_type_en': "School",
        'usage_type_es': "Escuela"
    },
    {
        'id': 22,
        'name_ca': 'Hotel',
        'name_es': 'Hotel',
        'name_en': 'Hotel',
        'name_db': 'retail_and_industrial',
        'usage_type_ca': "Hotel",
        'usage_type_en': "Hotel",
        'usage_type_es': "Hotel"
    },
    {
        'id': 23,
        'name_ca': 'Sòl urbà consolidat',
        'name_es': 'Suelo urbano consolidado',
        'name_en': 'Consolidated urban land',
        'name_db': 'land',
        'usage_type_ca': "Sòl urbà consolidat",
        'usage_type_en': "Consolidated urban land",
        'usage_type_es': "Suelo urbano consolidado"
    },
    {
        'id': 24,
        'name_ca': 'Sòl urbà no consolidat',
        'name_es': 'Suelo urbano no consolidado',
        'name_en': 'Unconsolidated urban land',
        'name_db': 'land',
        'usage_type_ca': "Sòl urbà no consolidat",
        'usage_type_en': "Unconsolidated urban land",
        'usage_type_es': "Suelo urbano no consolidado"
    },
    {
        'id': 25,
        'name_ca': 'Sòl urbanitzable programat',
        'name_es': 'Suelo urbanizable programado',
        'name_en': 'Programmed developable land',
        'name_db': 'land',
        'usage_type_ca': 'Sòl urbanitzable programat',
        'usage_type_es': 'Suelo urbanizable programado',
        'usage_type_en': 'Programmed developable land',
    },
    {
        'id': 26,
        'name_ca': 'Sòl urbanitzable no programat',
        'name_es': 'Suelo urbanizable no programado',
        'name_en': 'Unprogrammed developable land',
        'name_db': 'land',
        'usage_type_ca': 'Sòl urbanitzable no programat',
        'usage_type_es': 'Suelo urbanizable no programado',
        'usage_type_en': 'Unprogrammed developable land',
    },
    {
        'id': 27,
        'name_ca': 'Sòl no urbanitzable',
        'name_es': 'Suelo no urbanizable',
        'name_en': 'Non-buildable land',
        'name_db': 'land',
        'usage_type_ca': 'Sòl no urbanitzable',
        'usage_type_es': 'Suelo no urbanizable',
        'usage_type_en': 'Non-buildable land',
    }
]





// WEBPACK FOOTER //
// ./src/options/property_types.js